import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
	position: relative;
	width: 100%;
`

const Icon = styled.div`
	position: absolute;
	left: 12px;
	top: 50%;
	transform: translateY(-50%);
	display: inline-flex;
	align-items: center;
	justify-content: center;
	pointer-events: none;
	color: ${props => props.theme.colors.text.secondaryText};
`

const Field = styled.input`
	width: 100%;
	height: ${props => props.theme.sizes.forms.height};
	padding: 10px 16px 10px 32px;
	border: 1px solid ${props => props.theme.colors.greys.defaultBorder};
	border-radius: 8px;
	font-size: 16px;
	color: ${props => props.theme.colors.text.primaryText};
	background-color: ${props => props.theme.colors.brand.white};
	outline: none;

	&::placeholder {
		color: ${props => props.theme.colors.greys.disabledGrey};
	}

	&:focus {
		border-color: ${props => props.theme.colors.brand.blueOmint};
		box-shadow: 0 0 0 2px ${props => props.theme.colors.brand.backgroundBlue};
	}
`

const DatePickerIconInput = React.forwardRef(
	({ value, onClick, onChange, placeholder, className, inputClassName, icon }, ref) => {
		const mergedClassName = [className, inputClassName].filter(Boolean).join(' ')

		return (
			<Container>
				<Icon>{icon}</Icon>
				<Field
					ref={ref}
					type='text'
					className={mergedClassName}
					value={value || ''}
					onClick={onClick}
					onChange={onChange}
					placeholder={placeholder}
					readOnly
				/>
			</Container>
		)
	}
)

DatePickerIconInput.displayName = 'DatePickerIconInput'

export default DatePickerIconInput